import { ReportFeatures } from '@hcs/types';

export const REPORT_FEATURES_COMPS_LIST_FOOTER_SALE = [
  ReportFeatures.CompsSelect,
  ReportFeatures.CompsFarmView,
  ReportFeatures.CompsHcSuggested,
];
export const REPORT_FEATURES_COMPS_LIST_FOOTER_RENTAL = [
  ReportFeatures.RentalCompsSelect,
  ReportFeatures.RentalCompsFarmView,
];
